import { SignInForm } from 'components/Forms/Auth/SignIn';
import { AuthLayout } from 'components/Layout/Auth';
import { addApolloState, initializeApollo } from 'lib/clients/apolloClient';
import { GLOBAL } from 'queries';

const SignIn = () => {
  return <SignInForm />;
};

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  await Promise.all([
    apolloClient.query({
      query: GLOBAL,
    }),
  ]);

  return addApolloState(apolloClient, {
    props: {},
    revalidate: 60 * 5,
  });
}

SignIn.Layout = AuthLayout;

export default SignIn;
